<template>
  <section
    v-if="list.length" ref="announcement" :style="elementStyle(settings)" class="m-auto w-full"
  >
    <!-- 平铺 -->
    <div v-if="display_block" :style="elementStyle(datas?.settings.announcement.settings)">
      <div v-for="(item, index) in list" :id="item.id" :key="index" class="w-full flex-col">
        <nuxt-link :to="item.settings.link">
          <div :style="announcementItemStyle(item)">
            <marquee
              v-if="item.settings?.marqueePlay"
              :play="item.settings?.marqueePlay"
              :auto-fill="item.settings?.marqueeAutoFill ?? false"
              :speed="item.settings?.speed ?? 50"
              class="h-a"
            >
              <sps-text class="px-4 py-a" :value="item?.settings?.title_font">
                {{ item.settings.title }}
              </sps-text>
            </marquee>
            <sps-text v-else class="px-4 py-a" :value="item?.settings?.title_font">
              {{ item.settings.title }}
            </sps-text>
          </div>
        </nuxt-link>
      </div>
    </div>
    <!-- 紧凑 -->
    <div v-else-if="display_flex" :style="elementStyle(datas?.settings.announcement.settings)" class="w-full flex flex-wrap justify-between gap-2">
      <div v-for="(item, index) in list" :id="item.id" :key="index" class="w-full sm:w-49.5%">
        <nuxt-link :to="item.settings.link">
          <div :style="announcementItemStyle(item)">
            <marquee
              v-if="item.settings?.marqueePlay"
              :play="item.settings?.marqueePlay"
              :auto-fill="item.settings?.marqueeAutoFill ?? false"
              :speed="item.settings?.speed ?? 50"
              class="h-a"
            >
              <sps-text class="px-4 py-a" :value="item?.settings?.title_font">
                {{ item.settings.title }}
              </sps-text>
            </marquee>
            <sps-text v-else class="px-4 py-a" :value="item?.settings?.title_font">
              {{ item.settings.title }}
            </sps-text>
          </div>
        </nuxt-link>
      </div>
    </div>
    <!-- 上下/左右布局 -->
    <swiper
      v-else
      :key="`announcement-${Date.now()}`"
      auto-height
      :direction="direction"
      :modules="[SwiperAutoplay]"
      autoplay
      :loop="list?.length > 1"
      :slides-per-view="1"
      class="w-full"
      @init="oninit"
    >
      <swiper-slide
        v-for="(item, index) in list"
        :key="index"
        :style="announcementItemStyle(item)"
      >
        <nuxt-link class="wh-full flex items-center" :to="item.settings.link">
          <marquee
            v-if="item.settings?.marqueePlay"
            :play="item.settings?.marqueePlay"
            :auto-fill="item.settings?.marqueeAutoFill ?? false"
            :speed="item.settings?.speed ?? 50"
            class="w-full"
          >
            <sps-text class="w-full px-4" :value="item?.settings?.title_font">
              {{ item.settings.title }}
            </sps-text>
          </marquee>
          <sps-text v-else class="w-full px-4" :value="item?.settings?.title_font">
            {{ item.settings.title }}
          </sps-text>
        </nuxt-link>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script setup lang="ts">
import type Swiper from 'swiper'
import type { StyleValue } from 'vue'
import { elementStyle } from '~/utils/common'

defineOptions({
  name: 'AnnouncementSection',
})

const props = defineProps<{
  datas?: any
}>()

const isMobile = useIsMobile()

/**  设置项 */
const settings = computed(() => {
  return props.datas?.settings?.announcement?.settings
})

/**  显示模式 */
const direction = computed(() => {
  return isMobile.value ? (settings.value?.mob_display ?? 'block') : (settings.value?.pc_display ?? 'block')
})

/**  紧凑模式 */
const display_block = computed(() => direction.value === 'block')

/**  平铺模式 */
const display_flex = computed(() => direction.value === 'flex')

/**  过滤后的公告列表 */
const list = computed(() => {
  if (props.datas?.settings?.announcement?.blocks) {
    return props.datas?.settings?.announcement?.blocks?.filter((i: any) => !i.disabled) as Array<any>
  }
  return []
})

/**  公告项样式计算 */
const announcementItemStyle = (item: any): StyleValue => {
  const baseStyle = {
    textAlign: item.settings.align,
    backgroundColor: item.settings.color,
    color: item?.settings?.textColor,
  }

  return baseStyle
}

/**  当前组件Ref */
const announcement = ref<HTMLElement | null>(null)
const swiperRef = ref<Swiper | null>(null)

const oninit = (swiper: Swiper) => {
  swiperRef.value = swiper
}

const isVisible = useElementVisibility(announcement)

/**  自动播放:条件判断 */
watchEffect(() => {
  if ((direction.value === 'horizontal' || direction.value === 'vertical') && list.value.length) {
    if (isVisible.value) {
      swiperRef.value?.autoplay?.start()
    }
    else {
      swiperRef.value?.autoplay?.stop()
    }
  }
})
</script>
